import { Fragment, useEffect, useRef, useState } from "react";
import ModalTableProdutos from "../../modal/ModalTableProdutos";

import "./BodyRow.scss";
import {
	compareDates,
	getAllData,
	getDanfeVST,
	getStatusPedidos,
	valorMoeda,
} from "../../../services/Servicos";
import { useSelector } from "react-redux";
import ModalTableProdutosInformacoes from "../../modal/ModalTableProdutosInformacoes";
import { Spinner } from "react-bootstrap";
import ModalVisualizarDanfe from "../../modal/ModalVisualizarDanfe";
import ModalError from "../../modal/ModalError";
import ModalFinalizarPedidos from "../../modal/ModalFinalizarPedidos";
import ModalVisualizarCarga from "../../modal/ModalVisualizarCarga";
import { getFilialName, getColorOfFilial } from "../../../services/helpers";


export default function BodyRowPedidosFromPedidos({
	headList,
	bodyList,
	index,
	tableLength,
	cargas_id,
	setPedidos = () => {},
}) {
	const refRow = useRef(null);
	const refEditar = useRef(null);
	const user = useSelector((state) => state.userSlice);
	const filiaisList = user.filiaisList.data;

	const [loading, setLoading] = useState(false);
	const [loadingFunc, setLoadingFunc] = useState(true);
	const [produtos, setProdutos] = useState({
		flag: "",
		ID_EMPRESA: "",
		ID_FILIAL: "",
		ID_PEDIDO: "",
	});
	const [informacoesProdutos, setInformacoesProdutos] = useState({
		flag: "",
		ID_EMPRESA: "",
		ID_FILIAL: "",
		ID_PEDIDO: "",
	});

	const verInformacoesProdutos = (e, bodyList) => {
		e.preventDefault();
		const date = new Date(bodyList.dtemissao).toLocaleDateString("pt-BR", {
			timeZone: "UTC",
		});

		setInformacoesProdutos((last) => ({
			...last,
			flag: true,
			ID_EMPRESA: bodyList.idEmpresa,
			ID_FILIAL: bodyList.idFilial,
			ID_PEDIDO: bodyList.codigoPedido,
		}));
	};

	const onClickVerMais = (e, bodyList) => {
		e.preventDefault();
		const date = new Date(bodyList.dtemissao).toLocaleDateString("pt-BR", {
			timeZone: "UTC",
		});

		setProdutos((last) => ({
			...last,
			flag: true,
			ID_EMPRESA: bodyList.idEmpresa,
			ID_FILIAL: bodyList.idFilial,
			ID_PEDIDO: bodyList.codigoPedido,
			pedido: {
				id_filial: bodyList.idFilial,
				numero_pedido: bodyList.codigoPedido,
				emissao: date,
				nome_razao: bodyList.nomeRazao,
				nome_fantasia: bodyList.apelidoFantasia,
				cpf_cnpj: bodyList.cpfCnpj,
				endereco: bodyList.endereco,
				cep: bodyList.cep,
				bairro: bodyList.descbairro,
				cidade: bodyList.desccidade,
				numero: bodyList.numero,
				tel_1: bodyList.fonecelular,
				tel_2: bodyList.foneresidencial,
				valor_total: bodyList.vlrVenda,
				chave_nfe: bodyList.nfeChavedeacesso,
				nome_vendedor: bodyList.nomefunc,
				nfe_numero: bodyList.nfeNumero,
				cargas_id,
				peso_nf: bodyList.pesoBruto,
				responsavel: String(user.name).toUpperCase(),
				cpf_responsavel: String(user.cpf).toUpperCase(),
			},
		}));
	};

	const onClickTableRow = (e) => {
		e.preventDefault();
		refRow.current.classList += " bg-selected";
		let refRowNumber = refRow.current.children[0].innerText;

		let i = refRowNumber;
		let actualSibling = refRow.current.nextSibling;

		while (i < tableLength) {
			if (actualSibling === null) {
				break;
			}
			let classList = "";
			actualSibling.classList.forEach((e) => {
				classList += `${e} `;
			});
			actualSibling.classList = classList.replace("bg-selected", "");

			actualSibling = actualSibling.nextSibling;
			i++;
		}

		i = refRow.current.children[0].innerText;
		actualSibling = refRow.current.previousSibling;
		while (0 < i) {
			if (actualSibling === null) {
				break;
			}

			let classList = "";
			actualSibling.classList.forEach((e) => {
				classList += `${e} `;
			});
			actualSibling.classList = classList.replace("bg-selected", "");

			// actualSibling.classList = ''
			actualSibling = actualSibling.previousSibling;
			i--;
		}
	};

	const [verPDF, setVerPDF] = useState({
		show: false,
		PDF: "",
		title: "",
	});

	const [error, setError] = useState({
		flag: false,
	});

	const findDanfe = async (e, bodyList_) => {
		setLoading(true);

		const { codigoPedido, idFilial, apelidoFantasia } = bodyList_;

		setVerPDF({
			show: true,
			PDF: await getDanfeVST(idFilial, codigoPedido),
			title: "Danfe",
		});

		setError((last) => ({
			...last,
			numero_pedido: "",
		}));
		setLoading(false);
	};

	const [finalizarPedidos, setFinalizarPedidos] = useState({
		flag: false,
	});

	const [visualizarCarga, setVisualizarCarga] = useState({
		flag: false,
		cargaId: null,
	});

	const onClickAtualizarPedido = (e) => {
		const numero_pedido = bodyList.codigoPedido;
		const filial = bodyList.idFilial;
		setPedidos((last) => [
			...last.filter(
				(item) => item.codigoPedido != numero_pedido && item.idFilial != filial
			),
			...last
				.filter(
					(item) =>
						item.codigoPedido == numero_pedido && item.idFilial == filial
				)
				.map((item) => ({ ...item, stLogistica: 20 })),
		]);
	};

	const onClickVisualizarCarga = (e, cargaId) => {
		e.preventDefault();
		e.stopPropagation();
		if (cargaId) {
			setVisualizarCarga({
				flag: true,
				cargaId: cargaId,
			});
		}
	};

	useEffect(() => {
		if (window.location.pathname !== "/monitoramento-pedidos") return;
	}, []);
// Function to render styled status component
	const renderStyledStatus = (status) => {
		const statusNum = Number(status);
		
		// Status 27 - Entrega não concluída (Error/Failed)
		if (statusNum === 27) {
			return (
				<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
						<div className="div-status">
							<span className="div-status-inativo" style={{ backgroundColor: '#dc3545' }}>
								<i 
									className="bi bi-info-circle-fill" 
									style={{ color: '#ffffffff', fontSize: '1.1rem', marginRight: '4px' }}
									title="Clique para ver detalhes do problema"
								></i>
								{getStatusPedidos(status)}
							</span>
						</div>
				</div>
			);
		}
		
		// Status 24 - Finalizado/Concluído (Success)
		if (statusNum === 24) {
			return (
				<div className="div-status">
					<span className="div-status-ativo" style={{ backgroundColor: '#2846a7ff' }}>
						<i className="bi bi-check-circle me-1"></i>
						{getStatusPedidos(status)}
					</span>
				</div>
			);
		}
		
		// Default status (other values)
		return (
			<div className="div-status">
				{getStatusPedidos(status)}
			</div>
		);
	}; 

	// Função para determinar a cor baseada nos dias de logística
	const getCorDiasLogistica = (dias) => {
		if (dias <= 7) return { bg: "#2e7d32", color: "#ffffff" }; // Verde intenso com texto branco
		if (dias <= 14) return { bg: "#ff8f00", color: "#ffffff" }; // Laranja intenso com texto branco
		if (dias <= 28) return { bg: "#d32f2f", color: "#ffffff" }; // Vermelho intenso com texto branco
		return { bg: "#000000", color: "#ffffff" }; // Preto puro com texto branco
		};
	return (
		<Fragment>
			{
				<tr
					ref={refRow}
					onClick={onClickTableRow}
					className={
						!bodyList.nfeNumero || bodyList.nfeMod != "55" ? "rowDanger" : ""
					}
				>
					{headList.map((item, _index) => {
						if (item === "index") {
							return <td key={_index}> {index + 1}</td>;
						} else if (item.toLowerCase() === "admin") {
							return (
								<td key={_index}>
									<div className="admin" style={{ alignItems: "baseline" }}>
										{/* {} */}
										{['-1', '24', '27'].includes(bodyList.stLogistica) ? (
											bodyList.nfeNumero && bodyList.nfeMod == "55" ? (
												<span className="editar">
													<i
														className="bi bi-plus-circle"
														title="Ver Produtos"
														onClick={(e) => onClickVerMais(e, bodyList)}
														ref={refEditar}
													></i>
												</span>
											) : (
												<span className="editar">
													<i
														className="bi bi-exclamation-triangle"
														title="Ver Produtos"
													></i>
												</span>
											)
										) : (
											<span
												title="Pedido atrelado a uma carga"
												onClick={(e) => verInformacoesProdutos(e, bodyList)}
											>
												<i
													className="bi bi-question-circle"
													style={{ cursor: "pointer" }}
												></i>
											</span>
										)}
										{loading ? (
											<Spinner animation="border" size="sm" />
										) : (
											<i
												className="bi bi-file-earmark-pdf"
												onClick={(e) => {
													findDanfe(e, bodyList);
												}}
												style={{ cursor: "pointer" }}
											></i>
										)}
										{user.tipo.toLowerCase() === 'financeiro' ? 
										<span onClick={(e) => verInformacoesProdutos(e, bodyList)}
						>
										<i
											className="bi bi-exclamation-triangle"
											style={{ cursor: "pointer" }}
										></i>
											</span>
									:""}
									</div>
								</td>
							);
						} else if (item.toLowerCase() === "encerrar_pedido") {
							return (
								<td key={_index}>
									<div className="admin" style={{ alignItems: "baseline" }}>
										<span
											title="Encerrar Pedido sem Carga"
											onClick={(e) =>
												setFinalizarPedidos({
													flag: true,
													pedidos: [bodyList],
												})
											}
										>
											<i
												className="bi bi-exclamation-diamond"
												style={{ cursor: "pointer" }}
											></i>
										</span>
									</div>
								</td>
							);
						} else if (item === "status_pedido") {
							return (
								<td key={_index}>
									<span
										style={{
											fontSize: "0.8rem",
											padding: "7px 15px",
											borderRadius: "10px",
											backgroundColor:
												bodyList.stLogistica < 0
													? "#ff5757"
													: bodyList.stLogistica <= 2
													? "#00b4e1"
													: bodyList.stLogistica <= 5
													? "#c3e100"
													: "#00c66a",
										}}
									>
										{bodyList[item]}
									</span>
								</td>
							);
						} else if (item === "pesoBruto") {
							return (
								<td key={_index}>
									{Number(bodyList[item]).toLocaleString("pt-BR")}
								</td>
							);
						} else if (item === "idFilial") {
							return (
								<td key={_index}>
									<div style={{
										color: getColorOfFilial(bodyList.idFilial).color,
										backgroundColor: getColorOfFilial(bodyList.idFilial).bgColor,
										padding: '4px 6px',
										borderRadius: '4px',
										textAlign: 'center',
										boxShadow: '0 0 5px #0A061E80',
										border: '1px solid #E2E3DF80',
										width:'max-content'

									}}>
										{
											getFilialName(filiaisList, bodyList.idFilial)
										}
									</div>
								</td>
							);
						} else if (item === "vlrVenda") {
							return (
								<td key={_index} className="rowDataWidth">
									{valorMoeda(bodyList.vlrVenda)}
								</td>
							);
						} else if (item === 'stLogistica') {
							return <td key={_index} className='rowDataWidth'>
								{renderStyledStatus(bodyList.stLogistica)}
							</td>
						} 
						else if (item === 'data_logistica') {
							const hasCarga = bodyList.carga && bodyList.carga !== 'N/A';
							
							return (
								<td key={_index} className="carga-cell">
									{hasCarga ? (
										<div
											className="carga-clickable"
											onClick={(e) => onClickVisualizarCarga(e, bodyList.carga)}
											title={`Clique para ver detalhes da carga #${bodyList.carga}`}
										>
											<i className="bi bi-truck carga-icon"></i>
											<span>{bodyList.data_logistica}</span>
											<i className="bi bi-box-arrow-up-right carga-external-icon"></i>
										</div>
									) : (
										<div className="carga-no-data">
											{bodyList.data_logistica || 'N/A'}
										</div>
									)}
								</td>
							);
						}
						else if (item === 'dias_logistica') {
							const dias = bodyList.dias_logistica || 0;
							const corStyle = getCorDiasLogistica(dias);
							return (
								<td 
									key={_index} 
									style={{
										textAlign: 'center',
										padding: '8px'
									}}
									title={`${dias} dias de logística`}
								>
									<div
										style={{
											backgroundColor: corStyle.bg,
											color: corStyle.color,
											fontWeight: 'bold',
											padding: '6px 12px',
											borderRadius: '8px',
											display: 'inline-block',
											minWidth: '40px',
											fontSize: '0.9rem',
											boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
											border: `1px solid ${corStyle.bg}`
										}}
									>
										{dias}
									</div>
								</td>
							);
						}
						else if (
							[
								"dtemissao",
								"dtfaturamento",
								"dtcadastro",
								"data_cadastro",
								"data_faturamento",
							].includes(item)
						) {
							return bodyList[item] ? (
								<td key={_index}>
									{" "}
									{new Date(bodyList[item]).toLocaleDateString("pt-BR", {
										timeZone: "UTC",
									})}
								</td>
							) : (
								<td key={_index}></td>
							);
						}
						return (
							<td key={_index} className={item} style={{ minWidth: "100px" }}>
								{" "}
								{bodyList[item]}
							</td>
						);
					})}
				</tr>
			}
			{produtos.flag ? (
				<ModalTableProdutos
					show={produtos.flag}
					setShow={setProdutos}
					ID_EMPRESA={produtos.ID_EMPRESA}
					ID_FILIAL={produtos.ID_FILIAL}
					ID_PEDIDO={produtos.ID_PEDIDO}
					pedido={produtos.pedido}
					stLogistica={bodyList.stLogistica}
					setPedidos={setPedidos}
				/>
			) : (
				""
			)}
			{informacoesProdutos.flag ? (
				<ModalTableProdutosInformacoes
					show={informacoesProdutos.flag}
					setShow={setInformacoesProdutos}
					ID_EMPRESA={informacoesProdutos.ID_EMPRESA}
					ID_FILIAL={informacoesProdutos.ID_FILIAL}
					ID_PEDIDO={informacoesProdutos.ID_PEDIDO}
					pedido={informacoesProdutos.pedido}
					setPedidos={setPedidos}
				/>
			) : (
				""
			)}
			{verPDF.show ? (
				<ModalVisualizarDanfe
					title={verPDF.title}
					pdf={verPDF.PDF}
					setShow={setVerPDF}
					show={verPDF.show}
				/>
			) : (
				""
			)}
			{error.flag ? (
				<ModalError
					title={error.title}
					msg={error.msg}
					setShow={setError}
					show={error.flag}
				/>
			) : (
				""
			)}

			{finalizarPedidos.flag ? (
				<ModalFinalizarPedidos
					show={finalizarPedidos.flag}
					setShow={setFinalizarPedidos}
					{...finalizarPedidos}
					callback={onClickAtualizarPedido}
				/>
			) : (
				""
			)}

			{visualizarCarga.flag ? (
				<ModalVisualizarCarga
					show={visualizarCarga.flag}
					setShow={setVisualizarCarga}
					cargaId={visualizarCarga.cargaId}
				/>
			) : (
				""
			)}
		</Fragment>
	);
}
